<template>
  <v-container>
    <div>
      <v-dialog v-model="createDialog" max-width="650">
        <v-card>
          <v-card-title>
            <span class="headline"
              >{{ isEditing ? 'Update' : 'Create' }} Announcement</span
            >
          </v-card-title>
          <v-card-title>
            <v-form ref="form">
              <v-row>
                <v-col cols="12">
                  <v-select
                    v-model="newPost.type"
                    :items="announcementTypes"
                    label="Type"
                    filled
                    required
                    :rules="[rules.required]"
                  ></v-select>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="newPost.title"
                    label="Title"
                    filled
                    :required="newPost.type === 'popup'"
                    :rules="newPost.type === 'popup' ? [rules.required] : []"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-file-input
                    v-model="newPost.image"
                    filled
                    label="Image"
                    required
                    :rules="[rules.required]"
                  ></v-file-input>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="newPost.message"
                    label="Message"
                    filled
                    :required="newPost.type === 'popup'"
                    :rules="newPost.type === 'popup' ? [rules.required] : []"
                  ></v-textarea>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="newPost.buttonText"
                    label="Button Text"
                    filled
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="newPost.buttonLink"
                    label="Button Link"
                    filled
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="create" :loading="isCreating">{{
              isEditing ? 'Update' : 'Create'
            }}</v-btn>
            <v-btn color="error" @click="createDialog = false">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <h1 class="mb-5">Announcement</h1>
      <v-card flat>
        <v-container>
          <v-toolbar flat>
            <v-spacer></v-spacer>
            <v-btn color="primary" depressed @click="createDialog = true">
              <v-icon left>mdi-plus</v-icon>
              Create New Announcement</v-btn
            >
          </v-toolbar>
        </v-container>
        <v-card-text>
          <v-data-table
            :headers="tableheader"
            :items="announcements"
            :loading="loadingPost"
            :single-expand="true"
            show-expand
            item-key="_id"
          >
            <template v-slot:[`item.type`]="{ item }">
              <v-chip small :color="item.type === 'popup' ? 'indigo' : 'teal'" dark class="text-capitalize">
                {{ item.type }}
              </v-chip>
            </template>
            <template v-slot:[`item.createdAt`]="{ item }">
              <span>
                {{ item.createdAt | formatDate }}
              </span>
            </template>
            <template v-slot:[`item.updatedAt`]="{ item }">
              <span>
                {{ item.updatedAt | formatDate }}
              </span>
            </template>
            <template v-slot:[`item.status`]="{ item }">
              <span
                :class="`d-block text-center text-capitalize rounded py-2 px-3 white--text ${
                  item.active ? 'success' : 'error'
                }`"
                >{{ item.active ? 'Active' : 'Inactive' }}</span
              >
            </template>
            <template v-slot:[`item.action`]="{ item }">
              <v-menu bottom left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on">
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item ripple>
                    <v-list-item-title @click="selectedAnnouncement(item)"
                      >View</v-list-item-title
                    >
                  </v-list-item>

                  <v-list-item
                    v-if="!item.active"
                    @click="makeActive(item._id)"
                    ripple
                  >
                    <v-list-item-title>Make Active</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="item.active"
                    @click="makeInactive(item._id)"
                    ripple
                  >
                    <v-list-item-title>Make Inactive</v-list-item-title>
                  </v-list-item>

                  <v-list-item ripple @click="deleteAnnouncement(item._id)">
                    <v-list-item-title class="text--error"
                      >Delete</v-list-item-title
                    >
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length">
                <div class="w-full h-auto my-5">
                  <img :src="item.image" alt="Image" class="w-full h-auto" />
                </div>
                <div class="mt-4">{{ item.message }}</div>
                <div class="mt-4">{{ item.buttonText }}</div>
                <div class="mt-4 mb-8">{{ item.buttonLink }}</div>
              </td>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </div>

    <!-- <template v-else>
      <h1 class="error--text">You don't have access to this page</h1>
    </template> -->
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import announcement from '../../api/announcement'

const tableheader = [
  {
    value: 'type',
    text: 'Type'
  },
  {
    value: 'title',
    text: 'Title'
  },
  {
    value: 'createdAt',
    text: 'Posted Date'
  },
  {
    value: 'updatedAt',
    text: 'Updated Date'
  },
  {
    value: 'status',
    text: 'Status'
  },
  {
    value: 'action',
    text: '',
    sortable: false
  }
]

export default {
  name: 'Announcement',
  data: () => ({
    tableheader,
    createDialog: false,
    isCreating: false,
    announcements: [],
    loadingPost: false,
    isEditing: false,
    announcementTypes: ['popup', 'banner'],
    newPost: {
      type: '',
      title: '',
      message: '',
      buttonText: '',
      buttonLink: ''
    },
    rules: {
      required: (value) => !!value || 'Required',
      number: (value) =>
        (!!value && /^[0-9]+$/.test(value)) || 'Must be a number'
    }
  }),
  computed: {
    ...mapState({
      admin: (state) => state.admin.admin
    })
  },
  created() {
    this.getAnnouncements()
  },
  filters: {
    formatDate(value) {
      return new Date(value).toLocaleString()
    }
  },
  methods: {
    async selectedAnnouncement(post) {
      this.isEditing = true
      this.newPost = post
      this.createDialog = true
    },
    async getAnnouncements() {
      this.loadingPost = true
      const res = await announcement.announcement().get({
        orderBy: 'current',
        order: 'desc'
      })
      if (res.error) {
        this.$store.dispatch('alert', {
          message:
            res.errorMessage.message ||
            `${res.internalError.message}, please try again`,
          status: true,
          error: true
        })
        this.loadingPost = false
        return
      }

      this.loadingPost = false
      this.announcements = res.data.data.data
    },
    async create() {
      if (this.isEditing) {
        this.editAnnouncement()
        return
      }

      if (!this.$refs.form.validate()) return
      this.isCreating = true

      const formData = new FormData()
      formData.append('type', this.newPost.type)
      formData.append('title', this.newPost.title)
      formData.append('image', this.newPost.image)
      formData.append('message', this.newPost.message)
      formData.append('buttonText', this.newPost.buttonText)
      formData.append('buttonLink', this.newPost.buttonLink)

      const res = await announcement.announcement().create(formData)

      if (res.error) {
        this.$store.dispatch('alert', {
          message:
            res.errorMessage.message ||
            `${res.internalError.message}, please try again`,
          status: true,
          error: true
        })
        this.isCreating = false
        return
      }

      this.getAnnouncements()
      this.createDialog = false
      this.isCreating = false
    },
    async makeActive(id) {
      this.loadingPost = true
      const res = await announcement.announcement().makeActive({ id })
      if (res.error) {
        this.$store.dispatch('alert', {
          message:
            res.errorMessage.message ||
            `${res.internalError.message}, please try again`,
          status: true,
          error: true
        })
        return
      }
      this.getAnnouncements()
      this.loadingPost = false
    },
    async makeInactive(id) {
      this.loadingPost = true
      const res = await announcement.announcement().makeInactive({ id })
      if (res.error) {
        this.$store.dispatch('alert', {
          message:
            res.errorMessage.message ||
            `${res.internalError.message}, please try again`,
          status: true,
          error: true
        })
        return
      }
      this.getAnnouncements()
      this.loadingPost = false
    },
    async deleteAnnouncement(id) {
      this.loadingPost = true
      const res = await announcement.announcement().delete({ id })
      if (res.error) {
        this.$store.dispatch('alert', {
          message:
            res.errorMessage.message ||
            `${res.internalError.message}, please try again`,
          status: true,
          error: true
        })
        return
      }
      this.getAnnouncements()
      this.loadingPost = false
    },
    async editAnnouncement() {
      if (!this.$refs.form.validate()) return
      this.isCreating = true

      const payload = {
        type: this.newPost.type,
        title: this.newPost.title,
        image: this.newPost.image,
        message: this.newPost.message,
        buttonText: this.newPost.buttonText,
        buttonLink: this.newPost.buttonLink
      }

      const res = await announcement
        .announcement()
        .update({ id: this.newPost._id, data: payload })
      if (res.error) {
        this.$store.dispatch('alert', {
          message:
            res.errorMessage.message ||
            `${res.internalError.message}, please try again`,
          status: true,
          error: true
        })
        return
      }
      this.getAnnouncements()

      this.newPost = {
        type: '',
        title: '',
        message: '',
        buttonText: '',
        buttonLink: ''
      }
      this.isCreating = false
      this.isEditing = false
      this.createDialog = false
    }
  }
}
</script>

<style></style>
